import DashboardLayout from "@/layouts/DashboardLayout";
import * as g from '@/apps/auth/router/guards';

export default {
  path: "/news",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: "News",
      component: () => import("@/apps/news/components/NewsPage"),
      props: true,
      beforeEnter: g.ifAuthenticated,
      meta: { name: "Новости", backRoute: { label: 'Назад', name: 'Main'} }
    },
    {
      path: "/news/:manageOrganizationId/:postId",
      name: "NewsDetailPage",
      component: () => import("@/apps/news/components/NewsDetailPage"),
      props: true,
      beforeEnter: g.ifAuthenticated,
      meta: { name: "Подробней", backRoute: { label: 'Назад', name: 'News' } }
    },
  ]
};
